import React from "react"
import { Flex, Box } from "@rebass/grid/emotion"
import styled from "@emotion/styled"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { queries } from "@nutrafol/nutrafol-ui-kit/styles/mediaqueries"
import { ButtonWildMen } from "@nutrafol/nutrafol-ui-kit/dist/ButtonWildMen"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"
import FaqItem from "./faqitem"
import { buildFAQPage } from "../../../../utils/schemaHelper"
import Helmet from "react-helmet"

const AccordionTitle = styled(Box)`
  ${queries.medium`
    text-align: center;
  `}
  &.top-border {
    ${queries.large`
    border-top: 1px solid ${theme.wild.color.master.base.alt.secondary};
  `}
  }

  @media (min-width: 1024px) {
    h2 {
      font-size: 88px !important;
      line-height: 0.9 !important;
    }
  }

  .right {
    transform: none;
  }
`

const ButtonWildWrap = styled(Box)`
  margin: 24px 0 8px;
  @media (min-width: 768px) {
    margin: 24px 0 0;
  }
  @media (min-width: 1280px) {
    margin: 32px 0;
  }
  button.textLink {
    text-transform: uppercase;
    @media (min-width: 1280px) {
      font-size: 14px;
      line-height: 20px;
    }
  }

  button.textLink.faq-cta.men-core {
    ${queries.medium`
      font-size: 14px !important;
    `}
  }

  .faq-link.men-core {
    ${queries.medium`
      font-size: 14px !important;
    `}
  }
`

const FaqWrap = styled(Box)`
  color: #22202f;
  width: 100%;
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 768px) {
    padding-left: 40px;
    padding-right: 40px;
  }

  @media (min-width: 1280px) {
    padding-left: 56px;
    padding-right: 56px;
  }
`

const FaqBox = styled(Box)`
  background: #fff;

  padding-top: 32px;
  padding-bottom: 48px;
  padding-left: 32px;
  padding-right: 32px;

  @media (min-width: 768px) {
    border-radius: 4px;
    padding-top: 0;
    padding-bottom: 24px;
    padding-left: 16px;
    padding-right: 16px;
  }

  @media (min-width: 1024px) {
    padding-bottom: 40px;
    padding-left: 0;
    padding-right: 0;
  }
`

const label = "See All FAQs"

const Faq = ({ data, pageName }) => {
  const { heading, questions, pt, pb, hideFaqLink, hasTopBorder = true } = data

  return (
    <FaqWrap pt={pt} pb={pb}>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(buildFAQPage(questions))}
        </script>
      </Helmet>
      <FaqBox>
        <AccordionTitle
          pt={[16, null, 24, 72]}
          pb={hideFaqLink ? [26, null, 48, 96] : [16, null, 24, 64]}
          className={hasTopBorder ? "top-border" : "0"}
        >
          <Box maxWidth={[null, null, 700, 775]} mx="auto">
            <TextElementMen
              element="h2"
              text={heading}
              className="title--large text-master-secondary-default"
            />
          </Box>
          {!hideFaqLink ? (
            <ButtonWildWrap>
              <ButtonWildMen
                textLink
                arrowRight
                className={`faq-cta ${pageName}`}
                label={label}
                ctaLink="/men/faq/"
                trackObject={{
                  type: "link",
                  destination: "/men/faq/",
                  module_location: "bottom_fold",
                  text: label,
                }}
              />
            </ButtonWildWrap>
          ) : null}
        </AccordionTitle>
        <FaqItem questions={questions} />
      </FaqBox>
    </FaqWrap>
  )
}

export default Faq
